import RestApiModel from "@/api/Model/RestApiModel";
import api from "../index";

class Wording extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-wordings-ipr';
  }

  static setActive(id, params) {
    return api.patch(this.getResourceIdEndpoint(id, 'set-active'), params);
  }

  static update(id, params) {
    return api.post(this.getResourceIdEndpoint(id), params);
  }

  static downloadDocument(id, guid)  {
    return api.get(this.getResourceIdEndpoint(id) + '/document/' + guid,  { responseType: 'arraybuffer' });
  }
}

export default Wording;
